module.exports = __webpack_public_path__ + "static/media/iterative_learning_light.d0b2cc32.svg";